/**
 * Configuration de navigation pour les utilisateurs standard.
 * Les libellés sont résolus via t() dans useUserLayout.
 */
export const USER_NAV_CONFIG = [
  {
    id: "dashboard",
    icon: "dashboard",
    path: "/dashboard",
    tKey: "home",
    fallback: "Accueil",
  },
  {
    id: "community",
    icon: "community",
    path: "/community",
    tKey: "community",
    fallback: "Communauté",
  },
  {
    id: "recipes",
    icon: "recipes",
    path: "/recipes",
    tKey: "recipes",
    fallback: "Recettes",
  },
  {
    id: "shared-recipes",
    icon: "sharedRecipes",
    path: "/shared-recipes",
    tKey: "sharedRecipes",
    fallback: "Recettes partagées",
  },
  {
    id: "fridge-assistant",
    icon: "fridge",
    path: "/fridge-assistant",
    tKey: "fridgeAssistant",
    fallback: "Vide-Frigo",
  },
  {
    id: "world-menus",
    icon: "worldMenus",
    path: "/world-menus",
    tKey: "worldMenus",
    fallback: "Menus du Monde",
  },
  {
    id: "favorites",
    icon: "favorites",
    path: "/favorites",
    tKey: "favorites",
    fallback: "Favoris",
  },
  {
    id: "create-poster",
    icon: "poster",
    path: "/create-poster",
    tKey: "createPoster",
    fallback: "Créer un poster",
  },
  {
    id: "profile",
    icon: "profile",
    path: "/profile",
    tKey: "profile",
    fallback: "Profil",
  },
];

/**
 * Configuration de navigation pour les administrateurs.
 */
export const ADMIN_NAV_CONFIG = [
  {
    id: "dashboard",
    icon: "dashboard",
    path: "/dashboard",
    tKey: "home",
    fallback: "Accueil",
  },
  {
    id: "admin",
    icon: "admin",
    path: "/admin",
    tKey: "admin",
    fallback: "Gestion utilisateurs",
  },
  {
    id: "recipes",
    icon: "recipes",
    path: "/recipes",
    tKey: "recipes",
    fallback: "Recettes",
  },
  {
    id: "community",
    icon: "community",
    path: "/community",
    tKey: "community",
    fallback: "Communauté",
  },
  {
    id: "profile",
    icon: "profile",
    path: "/profile",
    tKey: "profile",
    fallback: "Profil",
  },
];

export const getNavConfigByRole = (role) =>
  String(role || "").toLowerCase() === "admin"
    ? ADMIN_NAV_CONFIG
    : USER_NAV_CONFIG;
